<template>
  <div class="exhibit-videos">
    <div
      v-for="(video,ind) in videos"
      :key="ind"
      class="thumbnail"
    >
      <vue-plyr
        ref="plyrinstance"
        :options="{fullscreen: { enabled: true }, controls: ['play-large', 'play', 'progress', 'current-time', 'fullscreen']}"
        :data-title="video.title"
      >
        <video :poster="video.cover.url">
          <source
            :src="video.file"
            type="video/mp4"
          >
        </video>
      </vue-plyr>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VuePlyr from 'vue-plyr'
Vue.use(VuePlyr)

export default {
  name: 'ExhibitVideos',
  props: {
    videos: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    plyrs() {
      // Nothing? Return an empty array
      if (!this.$refs.plyrinstance) {
        return []
      }
      // Already an array? return it
      if (Array.isArray(this.$refs.plyrinstance)) {
        return this.$refs.plyrinstance
      }
      // Otherwise, return an array of the instance itself
      return [this.$refs.plyrinstance]
    }
  },
  mounted() {
    const pps = this.plyrs
    // Tell the parent component about all the plyrs we have
    this.$emit('plyrs-loaded', pps)
  }
}
</script>
<style lang="scss" scoped>
.thumbnail {
    margin-bottom: 1rem;
}
</style>